import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-app-flexbox-grid';
import moment from 'moment';
import Payment from '../Payment/Payment';
import Loader from '../Loader/Loader';
import Error from '../Error/Error';
import './Transaction.css';
import { getTransaction } from '../../fetch';
import { network } from '../Network';
import Table from '../Table/Table';
import history from '../history';
import {convert} from '../currency';

class Transaction extends Component {
    constructor(props){
        super(props);
        let data = props.params.data;
        let error = props.params.error;
        if(data == null){
            if(
                typeof window !== "undefined" && 
                window != null && window.__INITIAL_STATE__ != null && 
                window.__INITIAL_STATE__.data != null
            ){
                data = window.__INITIAL_STATE__.data;
                window.__INITIAL_STATE__.data = null;
            }
        }
        if(error == null){
            if(
                typeof window !== "undefined" && window != null && 
                window.__INITIAL_STATE__ != null && 
                window.__INITIAL_STATE__.error != null
            ){
                error = window.__INITIAL_STATE__.error;
                window.__INITIAL_STATE__.error = null;
            }
        }
        this.state = {
            id: props.params.id,
            load: data == null && error == null, 
            error: error,
            transaction: data
        }
    }

    componentDidMount(){
        if(this.state.transaction == null && this.state.error == null){
            this.load();
        }
    }

    componentDidUpdate(){
        if(this.state.id !== this.props.params.id){
            this.setState({
                id: this.props.params.id,
                load: true, 
                error: null,
                transaction: null
            });
            this.load(this.props.params.id);
        }
    }

    load(id){
        if(this.state.load === false){
            this.setState({load: true});
        }
        if(id == null){
            id = this.state.id;
        }
        getTransaction(id,(data)=>{
            this.setState({load: false, error: data.error, transaction: data.data});
        }, network);
    }

    render() {
        if(this.state.transaction != null){
            var summary, signatures, other;

            summary = { 
                headers:[{width:"40%"},{width:"60%",align:'right'}],
                items:[
                    [{text:'Created at'},{text:moment(this.state.transaction.created_at).format('YYYY-MM-DD HH:mm:ss')}],
                    [{text:'Age'},{text:moment(this.state.transaction.created_at).fromNow()}],
                    [{text:'Fee'},{text:convert((this.state.transaction.fee_charged), "dbits") + " XDB"}],
                    [{text:'Ledger'},{text:this.state.transaction.ledger_attr, callback:()=>{history.push('/sequence/' + this.state.transaction.ledger_attr)}}],
                ]
            };

            other = { 
                headers:[{width:"40%"},{width:"60%",align:'right'}],
                items:[
                    [{text:'Paging Token'},{text:this.state.transaction.paging_token}],
                    [{text:'Sequence'},{text:this.state.transaction.source_account_sequence}],
                    [{text:'Memo text'},{text:(this.state.transaction.memo_type === 'none' ? "N/A" : (this.state.transaction.memo_type !== 'text' ? this.state.transaction.memo_type : this.state.transaction.memo))}],
                ]
            };

            signatures = {
                headers:[{width:"100%"}],
                items:[]
            };
            this.state.transaction.signatures.forEach(s => {
                signatures.items.push([{text:s}]);
            });
        }
        return ( 
            <Grid fluid className="transaction">
            {this.state.load && <Loader/>}
                {this.state.transaction != null &&
                    <Row>
                        <Col xs={12} md={12}>
                            <div className="transaction-block">
                                <h2 className="transaction-title">Transaction</h2>
                                <Payment payment={this.state.transaction} currency={this.props.currency}/>
                            </div>
                        </Col>
                        <Col xs={12} md={5} className="over">
                            <div className="transaction-block">
                                <h2 className="transaction-title">Summary</h2>
                                <Table data={summary}/>
                            </div>
                        </Col>
                        <Col xs={12} md={7}> 
                            <div className="transaction-block">
                                <h2 className="transaction-title">Other</h2>
                                <Table data={other}/>
                            </div>
                        </Col>
                        <Col xs={12} md={12} className="over">
                            <div className="transaction-block">
                                <h2 className="transaction-title">Signatures</h2>
                                <Table data={signatures}/>
                            </div>
                        </Col>
                    </Row>
                }
                {this.state.error != null &&
                    <Error message={this.state.error}/>
                }
            </Grid>
        );
    }
}

export default Transaction;


// WEBPACK FOOTER //
// ./src/components/Transaction/Transaction.js